import styled from 'styled-components';
import { device } from '../../styles/stylesheets';

export const Container = styled.div`
  min-height: 95vh;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 34px;
`;

export const ContentSpinner = styled.div`
  width: 100%;
  height: 100%;
`;

export const HeaderPage = styled.div`
  display: flex;
  flex: 1;
  margin-top: 7.2vh;
  margin-bottom: 7.2vh;
  align-items: center;
  height: 30px;
`;

export const TitlePage = styled.h1`
  font-size: 24px;
  line-height: 30px;
  margin: 0 30px;

  display: flex;
  width: 100%;
  justify-content: center;

  @media ${device.untilTablet} {
    font-size: 20px;
  }
`;

export const ContentCard = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 35px;
  column-gap: 24px;
  row-gap: 24px;
  @media ${device.untilTablet} {
    margin-right: 0px;
  }
`;
